// extracted by mini-css-extract-plugin
export default {"container":"SignIn_container__OVYCy","form":"SignIn_form__kJmGL","title":"SignIn_title__uF1GJ","link":"SignIn_link__o+hag"};